/**
 * 店舗グループ操作
 *
 * @param {string} GET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT         店舗グループ取得API
 * @param {string} VALIDATE_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT    店舗グループ保存バリデーションチェックAPI
 * @param {string} SET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT         店舗グループ保存API
 * @param {string} DELETE_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT      店舗グループ削除API
 * @author hayakawa 2024.08.23
 */

// インポート
import { auto_show_time, auto_hide_time, z_idx_top, z_idx_back, group_list_inner_height, organization_list_inner_height, employee_auth_id_manager, max_employee_organization_group, $spinner } from '../_constants';
import { showValidationErrors } from '../_functions';
import { addAllEmployeeOrganizationsGroup, addEmployeeOrganizationGroups, addAllOrganization, addOrganizations, canDisplay } from './_functions';
import { getHelpSearch, searchMatchingForHelp, searchMatchingForJob } from '../Shift/_functions';

// 定数
const $form_navigation = $('#form-navigation'),
    $modal_employee_organization_group_index = $('#modal-employee-organization-group-index'),
    $form_selected_organizations = $('#form-selected-organizations'),
    $modal_employee_organization_group_add = $('#modal-employee-organization-group-add'),
    $form_employee_organization_group_add = $('#form-employee-organization-group-add'),
    $modal_employee_organization_group_edit = $('#modal-employee-organization-group-edit'),
    $form_employee_organization_group_edit = $('#form-employee-organization-group-edit'),
    $modal_employee_organization = $('#modal-employee-organization'),
    $form_store_organization = $('#form-store-organization'),
    $form_update_organization = $('#form-update-organization'),
    $form_store_employee = $('#form-store-employee'),
    $form_update_employee = $('#form-update-employee'),
    $modal_help_rental = $('#modal-help-rental'),
    $modal_help_search = $('#modal-help-search'),
    $form_help_search = $('#form-help-search'),
    $modal_matching_search = $('#modal-matching-search'),
    $dropdown_menu_shift = $('#dropdown-menu-shift');

// 処理
$(function() {
    // 店舗グループ表示ボタンを押下
    $(document).on('click', 'button.btn-show-employee-organization-group', function() {
        // ボタンのパラメータを取得する
        const action_route = $(this).attr('data-action_route'),
            modal_for = $(this).attr('data-modal_for'),
            return_id = $(this).attr('id'),
            is_button = $(this).attr('data-is_button'),
            is_check_single = $(this).attr('data-is_check_single'),
            is_check_multiple = $(this).attr('data-is_check_multiple'),
            is_check_all = $(this).attr('data-is_check_all'),
            is_all = $(this).attr('data-is_all'),
            has_all = $(this).attr('data-has_all'),
            is_force_used_only = $(this).attr('data-is_force_used_only'),
            is_normal_only = $(this).attr('data-is_normal_only'),
            is_help_used_only = $(this).attr('data-is_help_used_only'),
            selected_company_id = $(this).attr('data-selected_company_id');
        let selected_organization_id = $(this).attr('data-selected_organization_id');

        // 閲覧モードの場合は終了 ※表示店舗の変更とダウンロードは許可
        if ($(this).hasClass('is-view-mode')) {
            switch (modal_for) {
                case 'display':
                case 'download-expenses':
                case 'download-works':
                    break;
                default:
                    return false;
            }
        }

        // ボタンのパラメータをFormに設定する
        $form_selected_organizations.attr('action', action_route);
        $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(modal_for);
        $form_selected_organizations.find('input[type="hidden"][name="return_id"]').val(return_id);
        $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(is_button);
        $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(is_check_single);
        $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(is_check_multiple);
        $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(is_check_all);
        $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(is_all);
        $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(has_all);
        $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(is_force_used_only);
        $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(is_normal_only);
        $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(is_help_used_only);
        $form_selected_organizations.find('input[type="hidden"][name="selected_company_id"]').val(selected_company_id);
        $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(selected_organization_id);

        // 画面のパラメータをコピーする
        if ($form_store_organization.length > 0) {
            $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val($form_store_organization.find('input[type="hidden"][name="organization_id"]').val())
        }

        if ($form_update_organization.length > 0) {
            $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val($form_update_organization.find('input[type="hidden"][name="organization_id"]').val())
        }

        if ($form_store_employee.length > 0) {
            $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val($form_store_employee.find('input[type="hidden"][name="employee_id"]').val())
        }

        if ($form_update_employee.length > 0) {
            $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val($form_update_employee.find('input[type="hidden"][name="employee_id"]').val())
        }

        if ($form_navigation.length > 0) {
            // 日計表
            $form_selected_organizations.find('input[type="hidden"][name="view_date_from"]').val($form_navigation.find('input[type="hidden"][name="view_date_from"]').val());
            $form_selected_organizations.find('input[type="hidden"][name="view_date_to"]').val($form_navigation.find('input[type="hidden"][name="view_date_to"]').val());

            // 労務
            $form_selected_organizations.find('input[type="hidden"][name="view_date"]').val($form_navigation.find('input[type="hidden"][name="view_date"]').val());
            $form_selected_organizations.find('input[type="hidden"][name="work_type"]').val($form_navigation.find('input[type="hidden"][name="work_type"]').val());
            $form_selected_organizations.find('input[type="hidden"][name="alert_flag"]').val($form_navigation.find('input[type="hidden"][name="alert_flag"]').val());
        }

        if (modal_for === 'help-possible-setting') {
            if ($form_help_search.length > 0) {
                $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val($form_help_search.find('input[type="hidden"][name="organization_id"]').val());
                $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val($form_help_search.find('input[type="hidden"][name="help_to_organization_ids"]').val());
            } else if ($modal_matching_search.hasClass('show')) {
                $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val($form_navigation.find('input[type="hidden"][name="organization_id"]').val());
                $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val($modal_matching_search.find('input[type="hidden"][name="help_to_organization_ids"]').val());
            } else {
                $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val($form_navigation.find('input[type="hidden"][name="organization_id"]').val());
                $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val($(this).closest('label').find('input[type="hidden"][name="help_to_organization_ids"]').val());
            }
        }

        if (modal_for === 'help-request-setting') {
            $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val($form_navigation.find('input[type="hidden"][name="organization_id"]').val());
            $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val($(this).closest('tr').find('input[type="hidden"][name="help_from_organization_ids"]').val());
        }

        if (modal_for === 'help-setting') {
            selected_organization_id = $dropdown_menu_shift.attr('data-organization_id');
            $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(selected_organization_id);
        }

        // パラメータ取得
        const params = new URLSearchParams(),
            $btn = $('button'),
            btn_html = $(this).html(),
            target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
            target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // 店舗グループ情報を取得する
        params.append('modal_for', modal_for);
        params.append('target_organization_id', target_organization_id);
        params.append('target_employee_id', target_employee_id);
        params.append('is_all', is_all);
        axios.get(`${GET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT}?${params.toString()}`)
        // 成功
        .then(res => {
            // 戻り値取得
            const data = res.data,
                organizations_all = data.organizations_all,
                employee_organization_groups = data.employee_organization_groups,
                can_select_organizations = data.can_select_organizations,
                can_add_organizations = data.can_add_organizations,
                employee_organization_group = data.employee_organization_group,
                charges_ids = data.charges_ids,
                unders_ids = data.unders_ids,
                help_request_ids = data.help_request_ids,
                help_possible_ids = data.help_possible_ids,
                organization_id_list = employee_organization_group.organization_id_list,
                organization_ids = organization_id_list.split(',');

            let selected_organization_ids = '';
            switch (modal_for) {
                case 'display':
                case 'belongs':
                case 'help-rental':
                case 'help-setting':
                    selected_organization_ids = [$form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val()];
                    break;
                case 'download-expenses':
                case 'download-works':
                    // 何もしない
                    break;
                case 'charges':
                    selected_organization_ids = charges_ids;
                    break;
                case 'unders':
                    selected_organization_ids = unders_ids;
                    break;
                case 'help-request-save':
                case 'help-request-organization-save':
                case 'help-request-setting':
                    const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                    if (prev_help_from_organization_ids === '') {
                        selected_organization_ids = help_request_ids;
                    } else {
                        selected_organization_ids = prev_help_from_organization_ids.split(',');
                    }
                    break;
                case 'help-possible-save':
                case 'help-possible-organization-save':
                case 'help-possible-setting':
                    const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                    if (prev_help_to_organization_ids === '') {
                        selected_organization_ids = help_possible_ids;
                    } else {
                        selected_organization_ids = prev_help_to_organization_ids.split(',');
                    }
                    break;
                default:
                    // 何もしない
                    break;
            }

            // 高さを計算
            let innerHeight = window.innerHeight * 0.5;
            if (innerHeight > group_list_inner_height) {
                innerHeight = group_list_inner_height;
            }

            // 左側（店舗グループ一覧）を作成
            $modal_employee_organization_group_index.find('section.group-list').find('ol').css('height', innerHeight + 25);
            $modal_employee_organization_group_index.find('section.group-list').find('ol').empty();

            // 1件目（全店舗）を作成
            addAllEmployeeOrganizationsGroup();

            // 登録済みの店舗グループ一覧を作成
            addEmployeeOrganizationGroups(employee_organization_groups);

            // 1件目を選択済みにする
            $modal_employee_organization_group_index.find('section.group-list').find(`a[data-employee_organization_group_id="${employee_organization_group.employee_organization_group_id}"]`).addClass('text-danger').addClass('font-weight-bolder');

            // 右側（店舗グループ詳細）を作成
            $modal_employee_organization_group_index.find('section.organization-list').find('ol').css('height', innerHeight);
            $modal_employee_organization_group_index.find('#active-employee-organization-group-name').text(employee_organization_group.group_name);
            $modal_employee_organization_group_index.find('section.organization-list').find('ol').empty();

            // 1件目（すべて）を作成
            if (is_button === '1' && has_all === '1') {
                addAllOrganization(selected_organization_id);
            }

            // 登録済みの店舗一覧を作成
            addOrganizations(can_select_organizations, organization_ids, selected_organization_id, selected_organization_ids, is_button, is_check_single, is_check_all, is_check_multiple, has_all, is_force_used_only, is_normal_only, is_help_used_only);

            // パラメータを設定
            $modal_employee_organization_group_index.find('input[name="employee_organization_group_id"]').val(employee_organization_group.employee_organization_group_id);

            // 検索メニューを調整する
            $modal_employee_organization_group_index.find('input[name="filter_organization_name"]').val('');
            $modal_employee_organization_group_index.find('input[name="filter_organization_address"]').val('');
            switch (modal_for) {
                case 'display':
                case 'belongs':
                case 'help-rental':
                case 'help-setting':
                    $form_selected_organizations.find('input[name="filter_organization_name"]').closest('label').show();
                    $form_selected_organizations.find('input[name="filter_organization_address"]').closest('label').show();
                    $form_selected_organizations.find('button.btn-checked-all').hide();
                    $form_selected_organizations.find('button.btn-unchecked-all').hide();
                    break;
                default:
                    $form_selected_organizations.find('input[name="filter_organization_name"]').closest('label').show();
                    $form_selected_organizations.find('input[name="filter_organization_address"]').closest('label').show();
                    $form_selected_organizations.find('button.btn-checked-all').show();
                    $form_selected_organizations.find('button.btn-unchecked-all').show();
                    break;
            }

            // ヘッダー・フッターを調整
            $modal_employee_organization_group_index.find('h5.modal-header-title').find('span').hide();
            $modal_employee_organization_group_index.find('div.modal-footer').find('button').not('.btn-close').hide();
            $modal_employee_organization_group_index.find(`.modal-for-${modal_for}`).show();

            // モーダルを表示
            $modal_employee_organization_group_index.modal('show');

            // 所属モーダルがある場合、後ろに下げる
            if ($modal_employee_organization.hasClass('show')) {
                $modal_employee_organization.css('z-index', z_idx_back);
            }

            // 他店貸出モーダルがある場合、後ろに下げる
            if ($modal_help_rental.hasClass('show')) {
                $modal_help_rental.css('z-index', z_idx_back);
            }

            // ヘルプから検索モーダルが有る場合、後ろに下げる
            if ($modal_help_search.hasClass('show')) {
                $modal_help_search.css('z-index', z_idx_back);
            }

            // マッチング検索モーダルが有る場合、後ろに下げる
            if ($modal_matching_search.hasClass('show')) {
                $modal_matching_search.css('z-index', z_idx_back);
            }

            if ($('.modal-backdrop').length > 1) {
                $('.modal-backdrop')[1].remove();
            }
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // 店舗グループモーダル hide時 他モーダルが有る場合復帰する
    $modal_employee_organization_group_index.on('hide.bs.modal', function(e) {
        // 所属
        if ($modal_employee_organization.hasClass('show')) {
            $modal_employee_organization.css('z-index', z_idx_top);
        }

        // 他店貸出
        if ($modal_help_rental.hasClass('show')) {
            $modal_help_rental.css('z-index', z_idx_top);
        }

        // ヘルプから検索
        if ($modal_help_search.hasClass('show')) {
            $modal_help_search.css('z-index', z_idx_top);
        }

        // マッチング検索
        if ($modal_matching_search.hasClass('show')) {
            $modal_matching_search.css('z-index', z_idx_top);
        }
    });

    // フィルターに文字を入力（AND検索）
    $(document).on('input', 'input[name="filter_organization_name"], input[name="filter_organization_address"], input[name="filter_organization_phone_number"]', function(e) {
        // パラメータ取得
        const $form = $(this).closest('form'),
            $input_organization_name = $form.find('input[name="filter_organization_name"]'),
            $input_organization_address = $form.find('input[name="filter_organization_address"]'),
            $input_organization_phone_number = $form.find('input[name="filter_organization_phone_number"]'),
            organization_name = $input_organization_name.length > 0 ? $input_organization_name.val() : '',
            organization_address = $input_organization_address.length > 0 ? $input_organization_address.val() : '',
            organization_phone_number = $input_organization_phone_number.length > 0 ? $input_organization_phone_number.val() : '';
        let $organization_list = $form.find('section.organization-list').find('ol').find('li');

        // 店舗一覧が存在する
        if ($organization_list.length > 0) {
            $organization_list.hide();

            // 店舗名が入力されている
            if (organization_name) {
                $organization_list = $organization_list.find(`span.organization-name:contains("${organization_name}")`).closest('li');
            }

            // 店舗住所が入力されている
            if (organization_address) {
                $organization_list = $organization_list.find(`span.organization-address:contains("${organization_address}")`).closest('li');
            }

            // 店舗電話番号が入力されている
            if (organization_phone_number) {
                $organization_list = $organization_list.find(`span.organization-phone-number:contains("${organization_phone_number}")`).closest('li');
            }

            // 残った店舗を表示
            $organization_list.show();

            // アクティブな店舗などは表示のままにする
            $form.find('section.organization-list').find('ol').find('li[data-organization_id="all"]').show();
            $form.find('section.organization-list').find('ol').find('li').find('button.active').closest('li').show();
            $form.find('section.organization-list').find('ol').find('li').find('input[type="checkbox"]:checked').closest('li').show();
        }
    });

    // フィルターで企業を変更
    $('select[name="filter_company_id"]').on('change', function(e) {
        const $form = $(this).closest('form'),
            filter_company_id = $(this).val();
        let $organization_list = $form.find('section.organization-list').find('ol').find('li');

        // 店舗一覧が存在する
        if ($organization_list.length > 0) {
            $organization_list.hide();

            // 該当の企業の店舗のみを抽出
            if (filter_company_id !== 'all') {
                $organization_list = $form.find('section.organization-list').find('ol').find(`li[data-company_id="${filter_company_id}"]`);
            }

            // 残った店舗を表示
            $organization_list.show();

            // アクティブな店舗などは表示のままにする
            $form.find('section.organization-list').find('ol').find('li[data-organization_id="all"]').show();
            $form.find('section.organization-list').find('ol').find('li').find('button.active').closest('li').show();
            $form.find('section.organization-list').find('ol').find('li').find('input[type="checkbox"]:checked').closest('li').show();
        }
    });

    // すべてチェック
    $('button.btn-checked-all').on('click', function() {
        // パラメータ取得
        const form_id = $(this).attr('data-form_id');

        $(`#${form_id}`).find('section.organization-list').find('li:visible').find('input[type="checkbox"]').prop('checked', true);
    });

    // すべて外す
    $('button.btn-unchecked-all').on('click', function() {
        // パラメータ取得
        const form_id = $(this).attr('data-form_id');

        $(`#${form_id}`).find('section.organization-list').find('li:visible').find('input[type="checkbox"]').prop('checked', false);
    });

    // 店舗グループ名クリック時
    $(document).on('click','#modal-employee-organization-group-index section.group-list li a', function() {
        // パラメータ取得
        const employee_organization_group_id = $(this).attr('data-employee_organization_group_id'),
            modal_for = $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(),
            target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
            target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val(),
            is_button = $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(),
            is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
            is_check_multiple = $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(),
            is_check_all = $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(),
            is_all = $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(),
            has_all = $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(),
            is_force_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(),
            is_normal_only = $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(),
            is_help_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(),
            selected_organization_id = $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(),
            params = new URLSearchParams(),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // 店舗グループ情報を取得する
        params.append('employee_organization_group_id', employee_organization_group_id);
        params.append('modal_for', modal_for);
        params.append('target_organization_id', target_organization_id);
        params.append('target_employee_id', target_employee_id);
        params.append('is_all', is_all);
        axios.get(`${GET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT}?${params.toString()}`)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                organizations_all = data.organizations_all,
                employee_organization_groups = data.employee_organization_groups,
                can_select_organizations = data.can_select_organizations,
                can_add_organizations = data.can_add_organizations,
                employee_organization_group = data.employee_organization_group,
                charges_ids = data.charges_ids,
                unders_ids = data.unders_ids,
                help_request_ids = data.help_request_ids,
                help_possible_ids = data.help_possible_ids,
                organization_id_list = employee_organization_group.organization_id_list,
                organization_ids = organization_id_list.split(',');

            let selected_organization_ids = '';
            switch (modal_for) {
                case 'display':
                case 'belongs':
                case 'help-rental':
                case 'help-setting':
                    selected_organization_ids = [selected_organization_id];
                    break;
                case 'download-expenses':
                case 'download-works':
                    // 何もしない
                    break;
                case 'charges':
                    selected_organization_ids = charges_ids;
                    break;
                case 'unders':
                    selected_organization_ids = unders_ids;
                    break;
                case 'help-request-save':
                case 'help-request-organization-save':
                case 'help-request-setting':
                    const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                    if (prev_help_from_organization_ids === '') {
                        selected_organization_ids = help_request_ids;
                    } else {
                        selected_organization_ids = prev_help_from_organization_ids.split(',');
                    }
                    break;
                case 'help-possible-save':
                case 'help-possible-organization-save':
                case 'help-possible-setting':
                    const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                    if (prev_help_to_organization_ids === '') {
                        selected_organization_ids = help_possible_ids;
                    } else {
                        selected_organization_ids = prev_help_to_organization_ids.split(',');
                    }
                    break;
                default:
                    // 何もしない
                    break;
            }

            // 左側（店舗グループ一覧）を調整
            $modal_employee_organization_group_index.find('section.group-list').find('a').removeClass('text-danger').removeClass('font-weight-bolder');
            $(this).addClass('text-danger').addClass('font-weight-bolder');

            // 右側（店舗グループ詳細）を作成
            $('#active-employee-organization-group-name').text(employee_organization_group.group_name);
            $modal_employee_organization_group_index.find('section.organization-list').find('ol').empty();

            // 1件目（すべて）を作成
            if (is_button === '1' && has_all === '1') {
                addAllOrganization(selected_organization_id);
            }

            // 登録済みの店舗一覧を作成
            addOrganizations(can_select_organizations, organization_ids, selected_organization_id, selected_organization_ids, is_button, is_check_single, is_check_all, is_check_multiple, has_all, is_force_used_only, is_normal_only, is_help_used_only);

            // 検索メニューを調整する
            $modal_employee_organization_group_index.find('input[name="filter_organization_name"]').val('');
            $modal_employee_organization_group_index.find('input[name="filter_organization_address"]').val('');

            // パラメータを設定
            $form_selected_organizations.find('input[name="employee_organization_group_id"]').val(employee_organization_group.employee_organization_group_id);
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err)
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // グループ新規作成 モーダル 表示
    $('#btn-show-employee-organization-group-add').on('click', function() {
        // 閲覧モードの場合は終了
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        // 件数チェック
        if ($modal_employee_organization_group_index.find('section.group-list').find('li').length >= max_employee_organization_group) {
            alert('店舗グループは10件までしか登録できません。');
            return false;
        }

        // パラメータ取得
        const modal_for = $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(),
            target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
            target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val(),
            is_button = $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(),
            is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
            is_check_multiple = $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(),
            is_check_all = $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(),
            is_all = $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(),
            has_all = $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(),
            is_force_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(),
            is_normal_only = $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(),
            is_help_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(),
            selected_organization_id = $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(),
            params = new URLSearchParams(),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // 店舗グループを取得
        params.append('modal_for', modal_for);
        params.append('target_organization_id', target_organization_id);
        params.append('target_employee_id', target_employee_id);
        params.append('is_all', is_all);
        axios.get(`${GET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT}?${params.toString()}`)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                organizations_all = data.organizations_all,
                employee_organization_groups = data.employee_organization_groups,
                can_select_organizations = data.can_select_organizations,
                can_add_organizations = data.can_add_organizations,
                employee_organization_group = data.employee_organization_group,
                charges_ids = data.charges_ids,
                unders_ids = data.unders_ids,
                help_request_ids = data.help_request_ids,
                help_possible_ids = data.help_possible_ids;

            let selected_organization_ids = '';
            switch (modal_for) {
                case 'display':
                case 'belongs':
                case 'help-rental':
                case 'help-setting':
                    selected_organization_ids = [selected_organization_id];
                    break;
                case 'download-expenses':
                case 'download-works':
                    // 何もしない
                    break;
                case 'charges':
                    selected_organization_ids = charges_ids;
                    break;
                case 'unders':
                    selected_organization_ids = unders_ids;
                    break;
                case 'help-request-save':
                case 'help-request-organization-save':
                case 'help-request-setting':
                    const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                    if (prev_help_from_organization_ids === '') {
                        selected_organization_ids = help_request_ids;
                    } else {
                        selected_organization_ids = prev_help_from_organization_ids.split(',');
                    }
                    break;
                case 'help-possible-save':
                case 'help-possible-organization-save':
                case 'help-possible-setting':
                    const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                    if (prev_help_to_organization_ids === '') {
                        selected_organization_ids = help_possible_ids;
                    } else {
                        selected_organization_ids = prev_help_to_organization_ids.split(',');
                    }
                    break;
                default:
                    // 何もしない
                    break;
            }

            // 高さを計算
            let innerHeight = window.innerHeight * 0.5;
            if (innerHeight > organization_list_inner_height) {
                innerHeight = organization_list_inner_height;
            }

            // 登録可能な店舗一覧を作成
            const exists_filter_company_id = $modal_employee_organization_group_add.find('select[name="filter_company_id"]').length > 0;

            $modal_employee_organization_group_add.find('section.organization-list').find('ol').css('height', innerHeight);
            $modal_employee_organization_group_add.find('section.organization-list').find('ol').empty();
            $.each(can_add_organizations, function(index, val) {
                const organization_name_w = exists_filter_company_id ? 'w-34' : 'w-68',
                    is_d_none = exists_filter_company_id ? '' : ' d-none',
                    $li = '' +
                    `<li class="" data-company_id="${val.company_id}">\n` +
                        `<label class="d-flex bg-white border-0">\n` +
                            `<input type="checkbox" name="organization_id[]" class="w-2 mr-1" value="${val.organization_id}">\n` +
                            `<span class="align-self-center w-34 text-nowrap overflow-hidden company-name${is_d_none}">${val.company_name}</span>\n` +
                            `<span class="align-self-center ${organization_name_w} text-nowrap overflow-hidden organization-name">${val.organization_name}</span>\n` +
                            `<span class="align-self-center w-16 text-nowrap overflow-hidden organization-address">${val.organization_address1}</span>\n` +
                            `<span class="align-self-center w-16 text-nowrap overflow-hidden organization-phone-number">${val.organization_phone_number}</span>\n` +
                        `</label>\n` +
                    `</li>\n`;

                $modal_employee_organization_group_add.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
            });

            // 企業セレクトを実行
            $form_employee_organization_group_add.find('select[name="filter_company_id"]').trigger('change');

            // モーダルの表示・非表示
            $modal_employee_organization_group_add.modal('show');
            $modal_employee_organization_group_index.css('z-index', z_idx_back);
            if ($('.modal-backdrop').length > 1) {
                $('.modal-backdrop')[1].remove();
            }
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // グループ新規作成 モーダル hide時 入力内容リセット
    $modal_employee_organization_group_add.on('hide.bs.modal', function(e) {
        $form_employee_organization_group_add.find('input[name="group_name"]').val('');
        $form_employee_organization_group_add.find('input[name="filter_organization_name"]').val('');
        $form_employee_organization_group_add.find('input[name="filter_organization_address"]').val('');
        $form_employee_organization_group_add.find('input[name="filter_organization_phone_number"]').val('');
        $modal_employee_organization_group_index.css('z-index', z_idx_top);
    });

    // グループ新規作成 保存ボタン押下時
    $('#btn-employee-organization-group-add').on('click', function() {
        // パラメータ取得
        const modal_for = $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(),
            target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
            target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val(),
            is_button = $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(),
            is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
            is_check_multiple = $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(),
            is_check_all = $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(),
            is_all = $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(),
            has_all = $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(),
            is_force_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(),
            is_normal_only = $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(),
            is_help_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(),
            selected_organization_id = $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(),
            $form_data = new FormData($form_employee_organization_group_add.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // 結果表示場所を初期化
        $modal_employee_organization_group_add.find('.exec-result-message').html('').hide();
        $form_employee_organization_group_add.find('.is-invalid').removeClass('is-invalid');
        $form_employee_organization_group_add.find('.invalid-feedback').text('');

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // バリデーションチェック
        axios.post(VALIDATE_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 店舗グループを登録
            params.append('modal_for', modal_for);
            params.append('target_organization_id', target_organization_id);
            params.append('target_employee_id', target_employee_id);
            params.append('is_all', is_all);
            axios.post(SET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT, params)
            // 成功
            .then(res => {
                // 戻り値を取得
                const data = res.data,
                    organizations_all = data.organizations_all,
                    employee_organization_groups = data.employee_organization_groups,
                    can_select_organizations = data.can_select_organizations,
                    can_add_organizations = data.can_add_organizations,
                    employee_organization_group = data.employee_organization_group,
                    charges_ids = data.charges_ids,
                    unders_ids = data.unders_ids,
                    help_request_ids = data.help_request_ids,
                    help_possible_ids = data.help_possible_ids,
                    organization_id_list = employee_organization_group.organization_id_list,
                    organization_ids = organization_id_list.split(',');

                let selected_organization_ids = '';
                switch (modal_for) {
                    case 'display':
                    case 'belongs':
                    case 'help-rental':
                    case 'help-setting':
                        selected_organization_ids = [selected_organization_id];
                        break;
                    case 'download-expenses':
                    case 'download-works':
                        // 何もしない
                        break;
                    case 'charges':
                        selected_organization_ids = charges_ids;
                        break;
                    case 'unders':
                        selected_organization_ids = unders_ids;
                        break;
                    case 'help-request-save':
                    case 'help-request-organization-save':
                    case 'help-request-setting':
                        const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                        if (prev_help_from_organization_ids === '') {
                            selected_organization_ids = help_request_ids;
                        } else {
                            selected_organization_ids = prev_help_from_organization_ids.split(',');
                        }
                        break;
                    case 'help-possible-save':
                    case 'help-possible-organization-save':
                    case 'help-possible-setting':
                        const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                    if (prev_help_to_organization_ids === '') {
                        selected_organization_ids = help_possible_ids;
                    } else {
                        selected_organization_ids = prev_help_to_organization_ids.split(',');
                    }
                        break;
                    default:
                        // 何もしない
                        break;
                }

                // 結果を表示
                setTimeout(function() {
                    $modal_employee_organization_group_add.find('.auto-show-hide').slideDown();
                }, auto_show_time);
                setTimeout(function() {
                    $modal_employee_organization_group_add.find('.auto-show-hide').slideUp();
                }, auto_hide_time);

                // 左側（店舗グループ一覧）を作成
                $modal_employee_organization_group_index.find('section.group-list').find('ol').empty();

                // 1件目（全店舗）を作成
                addAllEmployeeOrganizationsGroup();

                // 登録済みの店舗グループ一覧を作成
                addEmployeeOrganizationGroups(employee_organization_groups);

                // 登録した店舗グループを選択済みにする
                $modal_employee_organization_group_index.find('section.group-list').find(`a[data-employee_organization_group_id="${employee_organization_group.employee_organization_group_id}"]`).addClass('text-danger').addClass('font-weight-bolder');

                // 右側（店舗グループ詳細）を作成
                $('#active-employee-organization-group-name').text(employee_organization_group.group_name);
                $modal_employee_organization_group_index.find('section.organization-list').find('ol').empty();

                // 1件目（すべて）を作成
                if (is_button === '1' && has_all === '1') {
                    addAllOrganization(selected_organization_id);
                }

                // 登録済みの店舗一覧を作成
                addOrganizations(can_select_organizations, organization_ids, selected_organization_id, selected_organization_ids, is_button, is_check_single, is_check_all, is_check_multiple, has_all, is_force_used_only, is_normal_only, is_help_used_only);

                // 検索メニューを調整する
                $modal_employee_organization_group_index.find('input[name="filter_organization_name"]').val('');
                $modal_employee_organization_group_index.find('input[name="filter_organization_address"]').val('');
            })
            // 失敗
            .catch(err => {
                // 実行時エラー対応
                console.log(err);
                alert(err);
            })
            // 終了後
            .finally(() => {
                // ボタンを有効化
                $(this).html(btn_html);
                $btn.prop('disabled', false);

                // 登録数が10件になった場合はモーダルを閉じる
                if ($modal_employee_organization_group_index.find('section.group-list').find('li').length >= max_employee_organization_group) {
                    setTimeout(function() {
                        $modal_employee_organization_group_add.modal('hide');
                    }, auto_hide_time);
                }
            })
        })
        // 失敗
        .catch(err => {
            // バリデーションエラー対応
            const errors = err.response.data.errors;
            console.log(errors);
            showValidationErrors(errors, $form_employee_organization_group_add, $modal_employee_organization_group_add);

            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
        // 終了後
        .finally(() => {
            // 何もしない
        })
    });

    // グループ 編集ボタン 押下時
    $(document).on('click', 'button.btn-show-employee-organization-group-edit', function() {
        // 閲覧モードの場合は終了
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        // パラメータ取得
        const employee_organization_group_id = $(this).attr('data-employee_organization_group_id'),
            modal_for = $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(),
            target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
            target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val(),
            is_button = $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(),
            is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
            is_check_multiple = $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(),
            is_check_all = $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(),
            is_all = $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(),
            has_all = $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(),
            is_force_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(),
            is_normal_only = $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(),
            is_help_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(),
            selected_organization_id = $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(),
            $form_data = new FormData($form_employee_organization_group_add.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // 店舗グループを取得
        params.append('modal_for', modal_for);
        params.append('target_organization_id', target_organization_id);
        params.append('target_employee_id', target_employee_id);
        params.append('is_all', is_all);
        params.append('employee_organization_group_id', employee_organization_group_id);
        axios.get(`${GET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT}?${params.toString()}`)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                organizations_all = data.organizations_all,
                employee_organization_groups = data.employee_organization_groups,
                can_select_organizations = data.can_select_organizations,
                can_add_organizations = data.can_add_organizations,
                employee_organization_group = data.employee_organization_group,
                charges_ids = data.charges_ids,
                unders_ids = data.unders_ids,
                help_request_ids = data.help_request_ids,
                help_possible_ids = data.help_possible_ids,
                organization_id_list = employee_organization_group.organization_id_list,
                organization_ids = organization_id_list.split(',');

            let selected_organization_ids = '';
            switch (modal_for) {
                case 'display':
                case 'belongs':
                case 'help-rental':
                case 'help-setting':
                    selected_organization_ids = [selected_organization_id];
                    break;
                case 'download-expenses':
                case 'download-works':
                    // 何もしない
                    break;
                case 'charges':
                    selected_organization_ids = charges_ids;
                    break;
                case 'unders':
                    selected_organization_ids = unders_ids;
                    break;
                case 'help-request-save':
                case 'help-request-organization-save':
                case 'help-request-setting':
                    const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                    if (prev_help_from_organization_ids === '') {
                        selected_organization_ids = help_request_ids;
                    } else {
                        selected_organization_ids = prev_help_from_organization_ids.split(',');
                    }
                    break;
                case 'help-possible-save':
                case 'help-possible-organization-save':
                case 'help-possible-setting':
                    const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                    if (prev_help_to_organization_ids === '') {
                        selected_organization_ids = help_possible_ids;
                    } else {
                        selected_organization_ids = prev_help_to_organization_ids.split(',');
                    }
                    break;
                default:
                    // 何もしない
                    break;
            }

            // 高さを計算
            let innerHeight = window.innerHeight * 0.5;
            if (innerHeight > organization_list_inner_height) {
                innerHeight = organization_list_inner_height;
            }

            // 店舗一覧を作成
            const exists_filter_company_id = $modal_employee_organization_group_edit.find('select[name="filter_company_id"]').length > 0;

            $modal_employee_organization_group_edit.find('section.organization-list').find('ol').css('height', innerHeight);
            $modal_employee_organization_group_edit.find('section.organization-list').find('ol').empty();
            $.each(can_add_organizations, function(index, val) {
                const organization_name_w = exists_filter_company_id ? 'w-34' : 'w-68',
                    is_d_none = exists_filter_company_id ? '' : ' d-none',
                    is_checked = ($.inArray(String(val.organization_id), organization_ids) !== -1) ? ' checked' : '',
                    $li = '' +
                    `<li class="" data-company_id="${val.company_id}">\n` +
                        `<label class="d-flex bg-white border-0">\n` +
                            `<input type="checkbox" name="organization_id[]" class="w-2 mr-1" value="${val.organization_id}"${is_checked}>\n` +
                            `<span class="align-self-center w-34 text-nowrap overflow-hidden company-name${is_d_none}">${val.company_name}</span>\n` +
                            `<span class="align-self-center ${organization_name_w} text-nowrap overflow-hidden organization-name">${val.organization_name}</span>\n` +
                            `<span class="align-self-center w-16 text-nowrap overflow-hidden organization-address">${val.organization_address1}</span>\n` +
                            `<span class="align-self-center w-16 text-nowrap overflow-hidden organization-phone-number">${val.organization_phone_number}</span>\n` +
                        `</label>\n` +
                    `</li>\n`;

                if (is_checked) {
                    if ($modal_employee_organization_group_edit.find('section.organization-list').find('ol').find('input[type="checkbox"]:checked').length > 0) {
                        $modal_employee_organization_group_edit.find('section.organization-list').find('ol').find('input[type="checkbox"]:checked').closest('li').last().after($($li).prop('outerHTML'));
                    } else {
                        $modal_employee_organization_group_edit.find('section.organization-list').find('ol').prepend($($li).prop('outerHTML'));
                    }
                } else {
                    $modal_employee_organization_group_edit.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
                }
            });

            // パラメータを設定
            $form_employee_organization_group_edit.find('input[name="employee_organization_group_id"]').val(employee_organization_group.employee_organization_group_id);
            $form_employee_organization_group_edit.find('input[name="group_name"]').val(employee_organization_group.group_name);

            // 企業セレクトを実行
            $form_employee_organization_group_edit.find('select[name="filter_company_id"]').trigger('change');

            // モーダルの表示・非表示
            $modal_employee_organization_group_edit.modal('show');
            $modal_employee_organization_group_index.css('z-index', z_idx_back);
            if ($('.modal-backdrop').length > 1) {
                $('.modal-backdrop')[1].remove();
            }
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // グループ 編集モーダル hide時
    $modal_employee_organization_group_edit.on('hide.bs.modal', function(e){
        $form_employee_organization_group_edit.find('input[name="filter_organization_name"]').val('');
        $form_employee_organization_group_edit.find('input[name="filter_organization_address"]').val('');
        $form_employee_organization_group_edit.find('input[name="filter_organization_phone_number"]').val('');
        $modal_employee_organization_group_index.css('z-index', z_idx_top);
    });

    // グループ編集 保存ボタン押下時
    $('#btn-employee-organization-group-edit').on('click', function() {
        // パラメータ取得
        const view_employee_organization_group_id = $modal_employee_organization_group_index.find('input[name="employee_organization_group_id"]').val(),
            modal_for = $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(),
            target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
            target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val(),
            is_button = $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(),
            is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
            is_check_multiple = $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(),
            is_check_all = $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(),
            is_all = $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(),
            has_all = $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(),
            is_force_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(),
            is_normal_only = $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(),
            is_help_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(),
            selected_organization_id = $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(),
            $form_data = new FormData($form_employee_organization_group_edit.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // 結果表示場所を初期化
        $modal_employee_organization_group_edit.find('.exec-result-message').html('').hide();
        $form_employee_organization_group_edit.find('.is-invalid').removeClass('is-invalid');
        $form_employee_organization_group_edit.find('.invalid-feedback').text('');

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // バリデーションチェック
        axios.post(VALIDATE_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 店舗グループを更新
            params.append('modal_for', modal_for);
            params.append('target_organization_id', target_organization_id);
            params.append('target_employee_id', target_employee_id);
            params.append('is_all', is_all);
            axios.post(SET_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT, params)
            // 成功
            .then(res => {
                // 戻り値を取得
                const data = res.data,
                    organizations_all = data.organizations_all,
                    employee_organization_groups = data.employee_organization_groups,
                    can_select_organizations = data.can_select_organizations,
                    can_add_organizations = data.can_add_organizations,
                    employee_organization_group = data.employee_organization_group,
                    charges_ids = data.charges_ids,
                    unders_ids = data.unders_ids,
                    help_request_ids = data.help_request_ids,
                    help_possible_ids = data.help_possible_ids,
                    organization_id_list = employee_organization_group.organization_id_list,
                    organization_ids = organization_id_list.split(',');

                let selected_organization_ids = '';
                switch (modal_for) {
                    case 'display':
                    case 'belongs':
                    case 'help-rental':
                    case 'help-setting':
                        selected_organization_ids = [selected_organization_id];
                        break;
                    case 'download-expenses':
                    case 'download-works':
                        // 何もしない
                        break;
                    case 'charges':
                        selected_organization_ids = charges_ids;
                        break;
                    case 'unders':
                        selected_organization_ids = unders_ids;
                        break;
                    case 'help-request-save':
                    case 'help-request-organization-save':
                    case 'help-request-setting':
                        const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                        if (prev_help_from_organization_ids === '') {
                            selected_organization_ids = help_request_ids;
                        } else {
                            selected_organization_ids = prev_help_from_organization_ids.split(',');
                        }
                        break;
                    case 'help-possible-save':
                    case 'help-possible-organization-save':
                    case 'help-possible-setting':
                        const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                        if (prev_help_to_organization_ids === '') {
                            selected_organization_ids = help_possible_ids;
                        } else {
                            selected_organization_ids = prev_help_to_organization_ids.split(',');
                        }
                        break;
                    default:
                        // 何もしない
                        break;
                }

                // 結果を表示
                setTimeout(function() {
                    $modal_employee_organization_group_edit.find('.auto-show-hide').slideDown();
                }, auto_show_time);
                setTimeout(function() {
                    $modal_employee_organization_group_edit.find('.auto-show-hide').slideUp();
                }, auto_hide_time);

                // 左側（店舗グループ一覧）を作成
                $modal_employee_organization_group_index.find('section.group-list').find('ol').empty();

                // 1件目（全店舗）を作成
                addAllEmployeeOrganizationsGroup();

                // 登録済みの店舗グループ一覧を作成
                addEmployeeOrganizationGroups(employee_organization_groups);

                // 選択されていた店舗グループを選択済みにする
                $modal_employee_organization_group_index.find('section.group-list').find(`a[data-employee_organization_group_id="${view_employee_organization_group_id}"]`).addClass('text-danger').addClass('font-weight-bolder');

                // 選択していたグループを編集した場合
                if (view_employee_organization_group_id == employee_organization_group.employee_organization_group_id) {
                    // 右側（店舗グループ詳細）を作成
                    $('#active-employee-organization-group-name').text(employee_organization_group.group_name);
                    $modal_employee_organization_group_index.find('section.organization-list').find('ol').empty();

                    // 1件目（すべて）を作成
                    if (is_button === '1' && has_all === '1') {
                        addAllOrganization(selected_organization_id);
                    }

                    // 登録済みの店舗一覧を作成
                    addOrganizations(can_select_organizations, organization_ids, selected_organization_id, selected_organization_ids, is_button, is_check_single, is_check_all, is_check_multiple, has_all, is_force_used_only, is_normal_only, is_help_used_only);

                    // 検索メニューを調整する
                    $modal_employee_organization_group_index.find('input[name="filter_organization_name"]').val('');
                    $modal_employee_organization_group_index.find('input[name="filter_organization_address"]').val('');
                }
            })
            // 失敗
            .catch(err => {
                // 実行時エラー対応
                console.log(err);
                alert(err);
            })
            // 終了後
            .finally(() => {
                // ボタンを有効化
                $(this).html(btn_html);
                $btn.prop('disabled', false);
            })
        })
        // 失敗
        .catch(err => {
            // バリデーションエラー対応
            const errors = err.response.data.errors;
            console.log(errors);
            showValidationErrors(errors, $form_employee_organization_group_add, $modal_employee_organization_group_add);

            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
        // 終了後
        .finally(() => {
            // 何もしない
        })
    });

    // 店舗グループ 削除ボタン 押下時
    $(document).on('click', 'button.btn-delete-employee-organization-group', function() {
        // 閲覧モードの場合は終了
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        // 確認
        let ret = confirm('店舗グループを削除します。よろしいですか？');

        // OK
        if (ret) {
            // パラメータを取得
            const employee_organization_group_id = $(this).attr('data-employee_organization_group_id'),
                view_employee_organization_group_id = $modal_employee_organization_group_index.find('input[name="employee_organization_group_id"]').val(),
                modal_for = $form_selected_organizations.find('input[type="hidden"][name="modal_for"]').val(),
                target_organization_id = $form_selected_organizations.find('input[type="hidden"][name="target_organization_id"]').val(),
                target_employee_id = $form_selected_organizations.find('input[type="hidden"][name="target_employee_id"]').val(),
                is_button = $form_selected_organizations.find('input[type="hidden"][name="is_button"]').val(),
                is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
                is_check_multiple = $form_selected_organizations.find('input[type="hidden"][name="is_check_multiple"]').val(),
                is_check_all = $form_selected_organizations.find('input[type="hidden"][name="is_check_all"]').val(),
                is_all = $form_selected_organizations.find('input[type="hidden"][name="is_all"]').val(),
                has_all = $form_selected_organizations.find('input[type="hidden"][name="has_all"]').val(),
                is_force_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_force_used_only"]').val(),
                is_normal_only = $form_selected_organizations.find('input[type="hidden"][name="is_normal_only"]').val(),
                is_help_used_only = $form_selected_organizations.find('input[type="hidden"][name="is_help_used_only"]').val(),
                selected_organization_id = $form_selected_organizations.find('input[type="hidden"][name="selected_organization_id"]').val(),
                params = new URLSearchParams(),
                $btn = $('button'),
                btn_html = $(this).html();

            // ボタンを無効化
            $btn.prop('disabled', true);
            $(this).html($spinner);

            // 店舗グループを削除する
            params.append('employee_organization_group_id', employee_organization_group_id);
            params.append('modal_for', modal_for);
            params.append('target_organization_id', target_organization_id);
            params.append('target_employee_id', target_employee_id);
            params.append('is_all', is_all);
            axios.get(`${DELETE_EMPLOYEE_ORGANIZATION_GROUP_API_ENDPOINT}?${params.toString()}`)
            // 成功
            .then(res => {
                // 戻り値を取得
                const data = res.data,
                    organizations_all = data.organizations_all,
                    employee_organization_groups = data.employee_organization_groups,
                    can_select_organizations = data.can_select_organizations,
                    can_add_organizations = data.can_add_organizations,
                    employee_organization_group = data.employee_organization_group,
                    charges_ids = data.charges_ids,
                    unders_ids = data.unders_ids,
                    help_request_ids = data.help_request_ids,
                    help_possible_ids = data.help_possible_ids;

                let selected_organization_ids = '';
                switch (modal_for) {
                    case 'display':
                    case 'belongs':
                    case 'help-rental':
                    case 'help-setting':
                        selected_organization_ids = [selected_organization_id];
                        break;
                    case 'download-expenses':
                    case 'download-works':
                        // 何もしない
                        break;
                    case 'charges':
                        selected_organization_ids = charges_ids;
                        break;
                    case 'unders':
                        selected_organization_ids = unders_ids;
                        break;
                    case 'help-request-save':
                    case 'help-request-organization-save':
                    case 'help-request-setting':
                        const prev_help_from_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_from_organization_ids"]').val();
                        if (prev_help_from_organization_ids === '') {
                            selected_organization_ids = help_request_ids;
                        } else {
                            selected_organization_ids = prev_help_from_organization_ids.split(',');
                        }
                        break;
                    case 'help-possible-save':
                    case 'help-possible-organization-save':
                    case 'help-possible-setting':
                        const prev_help_to_organization_ids = $form_selected_organizations.find('input[type="hidden"][name="help_to_organization_ids"]').val();
                        if (prev_help_to_organization_ids === '') {
                            selected_organization_ids = help_possible_ids;
                        } else {
                            selected_organization_ids = prev_help_to_organization_ids.split(',');
                        }
                        break;
                    default:
                        // 何もしない
                        break;
                }

                // 結果表示
                $modal_employee_organization_group_index.find('.auto-show-hide').text('店舗グループを削除しました。');
                setTimeout(function() {
                    $modal_employee_organization_group_index.find('.auto-show-hide').slideDown();
                }, auto_show_time);
                setTimeout(function() {
                    $modal_employee_organization_group_index.find('.auto-show-hide').slideUp();
                }, auto_hide_time);

                // 該当の店舗グループを一覧から削除
                $modal_employee_organization_group_index.find('section.group-list').find(`a[data-employee_organization_group_id="${employee_organization_group_id}"]`).closest('li').remove();

                // 削除したグループを表示していた場合、右側（店舗グループ詳細）をリセットする
                if (view_employee_organization_group_id == employee_organization_group_id) {
                    $('#active-employee-organization-group-name').text('');
                    $modal_employee_organization_group_index.find('section.organization-list').find('ol').empty();

                    $modal_employee_organization_group_index.find('input[name="filter_organization_name"]').val('');
                    $modal_employee_organization_group_index.find('input[name="filter_organization_address"]').val('');
                }
            })
            // 失敗
            .catch(err => {
                // 実行時エラー対応
                console.log(err);
                alert(err);
            })
            // 終了後
            .finally(() => {
                // ボタンを有効化
                //$(this).html(btn_html); // 既に削除されているので戻す必要無し
                $btn.prop('disabled', false);
            })
        }
    });

    // 店舗ボタン押下（表示店舗変更）
    $(document).on('click', 'section.organization-list button', function() {
        // パラメータ取得
        const company_id = $(this).closest('li').attr('data-company_id'),
            organization_id = $(this).closest('li').attr('data-organization_id');

        $form_navigation.find('input[type="hidden"][name="company_id"]').val(company_id);
        $form_navigation.find('input[type="hidden"][name="organization_id"]').val(organization_id);
        $form_navigation.trigger('submit');
    });

    // 店舗チェック押下
    $(document).on('click', 'section.organization-list input[type="checkbox"]', function() {
        // パラメータ取得
        const is_check_single = $form_selected_organizations.find('input[type="hidden"][name="is_check_single"]').val(),
            is_checked = $(this).prop('checked');

        // 1つだけチェック可能な場合（所属店舗・貸出店舗）
        if (is_check_single === '1') {
            $form_selected_organizations.find('section.organization-list').find('input[type="checkbox"]').prop('checked', false);
            if (is_checked) {
                $(this).prop('checked', true);
            }
        }
    });

    // 設定ボタン押下（所属店舗）
    $('button.modal-for-belongs').on('click', function() {
        if ($form_selected_organizations.find('input[type="checkbox"]:checked').length > 0) {
            // パラメータ取得
            const return_id = $form_selected_organizations.find('input[type="hidden"][name="return_id"]').val(),
                $checked_input = $form_selected_organizations.find('input[type="checkbox"]:checked')[0],
                $li = $($checked_input).closest('li'),
                checked_company_id = $li.attr('data-company_id'),
                checked_organization_id = $li.attr('data-organization_id'),
                checked_organization_name = $li.find('span.organization-name').text();

            // 呼び出し元のボタンとインプットに新パラメータを設定
            $(`#${return_id}`).attr('data-selected_company_id', checked_company_id).attr('data-selected_organization_id', checked_organization_id).removeClass('placeholder').text(checked_organization_name);
            $(`#${return_id}`).closest('td').find('input[type="hidden"][name="organization_id[]"]').val(checked_organization_id);

            // モーダルを閉じる
            $modal_employee_organization_group_index.modal('hide');
        } else {
            alert('店舗が選択されていません。');
        }
    });

    // 保存ボタン押下（SV担当店舗）
    $('button.modal-for-charges').on('click', function() {
        // パラメータ取得
        const $form_data = new FormData($form_selected_organizations.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // SV担当店舗を保存する
        axios.post(SET_SURPERVISOR_ORGANIZATION_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                supervisor_organization = data.supervisor_organization,
                employee_id = data.employee_id;

            // 表示部分を再作成
            let $tbody = '';
            $.each(supervisor_organization, function(k, v) {
                $tbody += '' +
                    `<tr>\n` +
                        `<td>${v.organization_name}</td>\n` +
                    `</tr>\n`;
            })
            $('#tbl-supervisor-organization').find('tbody').html($tbody);

            // 仮データがない場合は保存の必用有り
            $('input[name="employee_id"]').val(employee_id);

            // 結果表示
            $modal_employee_organization_group_index.find('.auto-show-hide').text('SV担当店舗を保存しました。');
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideDown();
            }, auto_show_time);
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideUp();
            }, auto_hide_time);
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // 保存ボタン押下（オーナー配下店舗）
    $('button.modal-for-unders').on('click', function() {
        // パラメータ取得
        const $form_data = new FormData($form_selected_organizations.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // オーナー配下店舗を保存する
        axios.post(SET_SURPERVISOR_ORGANIZATION_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                supervisor_organization = data.supervisor_organization,
                employee_id = data.employee_id;

            // 表示部分を再作成
            let $tbody = '';
            $.each(supervisor_organization, function(k, v) {
                $tbody += '' +
                    `<tr>\n` +
                        `<td>${v.organization_name}</td>\n` +
                    `</tr>\n`;
            })
            $('#tbl-owner-organization').find('tbody').html($tbody);

            // 仮データがない場合は保存の必用有り
            $('input[name="employee_id"]').val(employee_id);

            // 結果表示
            $modal_employee_organization_group_index.find('.auto-show-hide').text('オーナー配下店舗を保存しました。');
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideDown();
            }, auto_show_time);
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideUp();
            }, auto_hide_time);
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // 保存ボタン押下（ヘルプ依頼店舗）※店舗
    $('button.modal-for-help-request-organization-save').on('click', function() {
        // パラメータ取得
        const $form_data = new FormData($form_selected_organizations.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // ヘルプ可能店舗を保存する
        axios.post(SET_ORGANIZATION_HELP_FROM_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                organization_help_from = data.organization_help_from,
                organization_id = data.organization_id;

            // 表示部分を再作成
            let $tbody = '';
            $.each(organization_help_from, function(k, v) {
                $tbody += '' +
                    `<tr>\n` +
                        `<td>${v.organization_name}</td>\n` +
                    `</tr>\n`;
            })
            $('#tbl-organization-help-from').find('tbody').html($tbody);

            // 仮データがない場合は保存の必用有り
            $('input[name="organization_id"]').val(organization_id);

            // 結果表示
            $modal_employee_organization_group_index.find('.auto-show-hide').text('ヘルプ依頼店舗を保存しました。');
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideDown();
            }, auto_show_time);
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideUp();
            }, auto_hide_time);
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // 保存ボタン押下（ヘルプ可能店舗）
    $('button.modal-for-help-possible-save').on('click', function() {
        // パラメータ取得
        const $form_data = new FormData($form_selected_organizations.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // ヘルプ可能店舗を保存する
        axios.post(SET_EMPLOYEE_HELP_ORGANIZATION_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                employee_help_organization = data.employee_help_organization,
                employee_id = data.employee_id;

            // 表示部分を再作成
            let $tbody = '';
            $.each(employee_help_organization, function(k, v) {
                $tbody += '' +
                    `<tr>\n` +
                        `<td>${v.organization_name}</td>\n` +
                    `</tr>\n`;
            })
            $('#tbl-employee-help-organization').find('tbody').html($tbody);

            // 仮データがない場合は保存の必用有り
            $('input[name="employee_id"]').val(employee_id);

            // 結果表示
            $modal_employee_organization_group_index.find('.auto-show-hide').text('ヘルプ可能店舗を保存しました。');
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideDown();
            }, auto_show_time);
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideUp();
            }, auto_hide_time);
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // 保存ボタン押下（ヘルプ可能店舗）※店舗
    $('button.modal-for-help-possible-organization-save').on('click', function() {
        // パラメータ取得
        const $form_data = new FormData($form_selected_organizations.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(this).html();

        // ボタンを無効化
        $btn.prop('disabled', true);
        $(this).html($spinner);

        // ヘルプ可能店舗を保存する
        axios.post(SET_ORGANIZATION_HELP_TO_API_ENDPOINT, params)
        // 成功
        .then(res => {
            // 戻り値を取得
            const data = res.data,
                organization_help_to = data.organization_help_to,
                organization_id = data.organization_id;

            // 表示部分を再作成
            let $tbody = '';
            $.each(organization_help_to, function(k, v) {
                $tbody += '' +
                    `<tr>\n` +
                        `<td>${v.organization_name}</td>\n` +
                    `</tr>\n`;
            })
            $('#tbl-organization-help-to').find('tbody').html($tbody);

            // 仮データがない場合は保存の必用有り
            $('input[name="organization_id"]').val(organization_id);

            // 結果表示
            $modal_employee_organization_group_index.find('.auto-show-hide').text('ヘルプ可能店舗を保存しました。');
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideDown();
            }, auto_show_time);
            setTimeout(function() {
                $modal_employee_organization_group_index.find('.auto-show-hide').slideUp();
            }, auto_hide_time);
        })
        // 失敗
        .catch(err => {
            // 実行時エラー対応
            console.log(err);
            alert(err);
        })
        // 終了後
        .finally(() => {
            // ボタンを有効化
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        })
    });

    // 設定ボタン押下（他店貸出）
    $('button.modal-for-help-rental').on('click', function() {
        if ($form_selected_organizations.find('input[type="checkbox"]:checked').length > 0) {
            // パラメータ取得
            const return_id = $form_selected_organizations.find('input[type="hidden"][name="return_id"]').val(),
                $checked_input = $form_selected_organizations.find('input[type="checkbox"]:checked')[0],
                $li = $($checked_input).closest('li'),
                checked_company_id = $li.attr('data-company_id'),
                checked_organization_id = $li.attr('data-organization_id'),
                checked_organization_name = $li.find('span.organization-name').text();

            // 呼び出し元のボタンとインプットに新パラメータを設定
            $(`#${return_id}`).attr('data-selected_company_id', checked_company_id).attr('data-selected_organization_id', checked_organization_id).removeClass('placeholder').text(checked_organization_name);
            $(`#${return_id}`).closest('td').find('input[type="hidden"][name="rental_organization_id"]').val(checked_organization_id);

            // モーダルを閉じる
            $modal_employee_organization_group_index.modal('hide');
        } else {
            alert('店舗が選択されていません。');
        }
    });

    // 設定ボタン押下（ヘルプ店舗設定）
    $('button.modal-for-help-setting').on('click', function() {
        if ($form_selected_organizations.find('input[type="checkbox"]:checked').length > 0) {
            // パラメータ取得
            const return_id = $form_selected_organizations.find('input[type="hidden"][name="return_id"]').val(),
                $checked_input = $form_selected_organizations.find('input[type="checkbox"]:checked')[0],
                $li = $($checked_input).closest('li'),
                checked_company_id = $li.attr('data-company_id'),
                checked_organization_id = $li.attr('data-organization_id'),
                checked_organization_name = $li.find('span.organization-name').text(),
                work_plan_id = $dropdown_menu_shift.attr('data-work_plan_id'),
                $div_shift_bar = $(`.div-shift-bar[data-work_plan_id=${work_plan_id}]`),
                work_type = $div_shift_bar.attr('data-work_type'),
                work_type_name = work_types[work_type],
                //work_type_name = $div_shift_bar.find('.role').text(),
                $tr = $div_shift_bar.closest('tr');

            // シフトオブジェクトを設定
            $div_shift_bar.attr('data-organization_id', checked_organization_id).attr('data-organization_name', checked_organization_name).attr('data-is_help', '1').attr('data-is_help_organization', '1').attr('data-help_go', '1').attr('data-state', 'updated');
            $div_shift_bar.find('.role').text(`${work_type_name} (${checked_organization_name})`);
            $tr.attr('data-is_help', '1').attr('data-is_help_organization', '1').attr('data-help_go', '1').attr('data-work_plan_state', 'updated');

            // シフト編集フラグを設定
            $form_navigation.find('input[type="hidden"][name="shift_edit_flag"]').val(1);

            // モーダルを閉じる
            $modal_employee_organization_group_index.modal('hide');
        } else {
            alert('店舗が選択されていません。');
        }
    });

    // 設定ボタン押下（ヘルプから検索（日次）、ヘルプ一覧（他店）、マッチング（ジョブ））
    $('button.modal-for-help-possible-setting').on('click', function() {
        const return_id = $form_selected_organizations.find('input[type="hidden"][name="return_id"]').val(),
            $lis = $form_selected_organizations.find('input[type="checkbox"]:checked').closest('li');

        if ($lis.length > 0) {
            // パラメータ初期化
            let help_to_organization_names = '',
                help_to_organization_ids = '';

            // 繰り返し
            $lis.each(function(index) {
                // パラメータ取得
                const checked_organization_id = $(this).attr('data-organization_id'),
                    checked_organization_name = $(this).find('span.organization-name').text();

                // パラメータ生成
                if (help_to_organization_names === '') {
                    help_to_organization_names += checked_organization_name;
                    help_to_organization_ids += checked_organization_id;
                } else {
                    help_to_organization_names += ' ' + checked_organization_name;
                    help_to_organization_ids += ',' + checked_organization_id;
                }
            });

            // ヘルプから検索（日次）の場合
            if ($form_help_search.length > 0) {
                // パラメータ設定
                $modal_help_search.find('section.help-to').text(help_to_organization_names);
                $form_help_search.find('input[type="hidden"][name="help_to_organization_ids"]').val(help_to_organization_ids);

                // モーダルを閉じる
                $modal_employee_organization_group_index.modal('hide');

                // 再検索する
                getHelpSearch('custom', $(this));

            // マッチングマッチング（ジョブ）の場合
            } else if ($modal_matching_search.hasClass('show')) {
                const mode = 'search',
                    employee_help_request_id = $modal_matching_search.attr('data-employee_help_request_id');

                // パラメータ設定
                $modal_matching_search.find('section.help-to-organization-names').text(help_to_organization_names);
                $modal_matching_search.find('input[type="hidden"][name="help_to_organization_ids"]').val(help_to_organization_ids);

                // 再検索する
                searchMatchingForJob(mode, $(this), employee_help_request_id);

                // モーダルを閉じる
                $modal_employee_organization_group_index.modal('hide');

            // ヘルプ一覧（他店）の場合
            } else {
                // パラメータ設定
                $('#filter').find('button.btn-show-employee-organization-group').text(help_to_organization_names);
                $('#filter').find('input[type="hidden"][name="help_to_organization_ids"]').val(help_to_organization_ids);

                // モーダルを閉じる
                $modal_employee_organization_group_index.modal('hide');
            }
        } else {
            alert('店舗が選択されていません。');
        }
    });

    // 設定ボタン押下（マッチング（ヘルプ一覧））
    $('button.modal-for-help-request-setting').on('click', function() {
        const mode = 'own-search',
            help_request_id = $modal_matching_search.attr('data-help_request_id'),
            $lis = $form_selected_organizations.find('input[type="checkbox"]:checked').closest('li');

        if ($lis.length > 0) {
            // パラメータ初期化
            let help_from_organization_names = '',
                help_from_organization_ids = '';

            // 繰り返し
            $lis.each(function(index) {
                // パラメータ取得
                const checked_organization_id = $(this).attr('data-organization_id'),
                    checked_organization_name = $(this).find('span.organization-name').text();

                // パラメータ生成
                if (help_from_organization_names === '') {
                    help_from_organization_names += checked_organization_name;
                    help_from_organization_ids += checked_organization_id;
                } else {
                    help_from_organization_names += ' ' + checked_organization_name;
                    help_from_organization_ids += ',' + checked_organization_id;
                }
            });

            // パラメータ設定
            $modal_matching_search.find('section.help-from-organization-names').text(help_from_organization_names);
            $modal_matching_search.find('input[type="hidden"][name="help_from_organization_ids"]').val(help_from_organization_ids);

            // 再検索する
            searchMatchingForHelp(mode, $(this), help_request_id);

            // モーダルを閉じる
            $modal_employee_organization_group_index.modal('hide');
        } else {
            alert('店舗が選択されていません。');
        }
    });

    // ダウンロードボタン押下
    $('button.btn-download-multiple').on('click', function() {
        if ($form_selected_organizations.find('input[type="checkbox"]:checked').length > 0) {
            $form_selected_organizations.trigger('submit');
        } else {
            alert('店舗がチェックされていません。');
        }
    });
});
